import styled from 'styled-components';
const resetFieldStyles = `
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  outline: none;
  border: 0px;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  width: 100%;`;
export const TextareaField = styled.textarea `
  ${resetFieldStyles}
  resize: none;
  font-size: ${({ theme, size = 'medium' }) => theme.form.size[size].fontSize};
  line-height: ${({ theme, size = 'medium' }) => theme.form.size[size].lineHeight};
  font-family: ${({ theme }) => theme.fonts.families.base};
  min-height: ${({ minHeight }) => (minHeight ? minHeight + 'px' : '126px')};
  padding: 12px 0px;
  ${({ maxLength }) => (maxLength ? 'margin-bottom: 20px;' : '')}

  &::-webkit-scrollbar {
    width: ${({ showScrollbar }) => `${showScrollbar ? 4 : 0}px`};
    background: ${({ showScrollbar, theme }) => (showScrollbar ? theme.colors.gray24 : 'transparent')};
  }
`;
export const CustomSup = styled.sup `
  color: red;
`;
